// MOCK DATA for Mariah Angeliq site

// Real Mariah Angeliq editorial photos
const IMG_PORTRAIT_CHOKER = 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/m85z5jm7_Screenshot%202026-04-17%20at%207.18.22%E2%80%AFPM.png';
const IMG_ROSES = 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/s9tajaop_Screenshot%202026-04-17%20at%207.19.09%E2%80%AFPM.png';
const IMG_ARMS_UP = 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/m6rwwg4e_Screenshot%202026-04-17%20at%207.19.33%E2%80%AFPM.png';
const IMG_DUO = 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/jkhiawwc_Screenshot%202026-04-17%20at%207.20.21%E2%80%AFPM.png';
const IMG_MIAMI_GOLD = 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/6pw4xo4q_Screenshot%202026-04-17%20at%207.20.44%E2%80%AFPM.png';

export const NAV_LINKS = [
  { label: 'Shop', href: '/shop' },
  { label: 'Videos', href: '/#videos' },
  { label: 'About', href: '/#about' },
  { label: 'Follow', href: '/#follow' },
  { label: 'Gallery', href: '/#gallery' },
];

export const SHOP_CATEGORIES = [
  { slug: 'all', label: 'All' },
  { slug: 'music', label: 'Music' },
  { slug: 'apparel', label: 'Apparel' },
  { slug: 'accessories', label: 'Accessories' },
  { slug: 'posters', label: 'Posters' },
];

export const MARQUEE_ITEMS = [
  'LA TÓXICA — US TOUR',
  '◆',
  'NEW SINGLE OUT NOW',
  '◆',
  'FREE SHIPPING OVER $75',
  '◆',
  'PRINCESA DE LA NOCHE',
  '◆',
  'SHOP EXCLUSIVE MERCH',
  '◆',
];

export const PRODUCTS = [
  {
    id: 'p1',
    slug: 'mariah-angeliq-hoodie-cream',
    name: 'Mariah Angeliq All-Over Hoodie — Cream',
    price: 95.00,
    category: 'apparel',
    tags: ['hoodie', 'signature'],
    images: [
      'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/hgrtnavr_16a9c4b5-9ef6-4c96-baae-d24ee7eb482e.png'
    ],
    color: 'transparent',
    description: 'Heavyweight cropped hoodie with all-over Mariah Angeliq script print. 100% premium cotton fleece, oversized fit.',
    badge: 'NEW'
  },
  {
    id: 'p2',
    slug: 'mariah-angeliq-hoodie-grey',
    name: 'Mariah Angeliq Center Logo Hoodie — Heather',
    price: 85.00,
    category: 'apparel',
    tags: ['hoodie', 'classic'],
    images: [
      'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/r6b12r57_a91967e3-858f-4f42-80ff-72cc6fcaea66.png'
    ],
    color: 'transparent',
    description: 'Heather grey cropped hoodie with red script Mariah Angeliq centered. Heavyweight fleece, oversized boxy fit.',
    badge: 'SIGNATURE'
  },
  {
    id: 'p3',
    slug: 'its-mariah-baby-shorts',
    name: 'It\'s Mariah Baby Sweat Shorts — Heather',
    price: 55.00,
    category: 'apparel',
    tags: ['shorts', 'summer'],
    images: [
      'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/4r8juf72_Untitled%20design.png'
    ],
    color: 'transparent',
    description: 'Heather grey heavyweight sweat shorts with red It\'s Mariah Baby script across the front. Relaxed fit with drawstring.',
    badge: 'NEW'
  },
  {
    id: 'p4',
    slug: 'its-mariah-baby-sweatpants',
    name: 'It\'s Mariah Baby Sweatpants — Heather',
    price: 78.00,
    category: 'apparel',
    tags: ['pants', 'signature'],
    images: [
      'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/0i7jzxc2_98bf70d4-ee7a-4588-b18f-faee6407f63a.png'
    ],
    color: 'transparent',
    description: 'Heather grey heavyweight sweatpants with red It\'s Mariah Baby cursive print down the leg. Wide-leg silhouette, elastic drawstring waist.',
    badge: 'NEW'
  },
  {
    id: 'p5',
    slug: 'bootleg-tee-rack',
    name: 'Bootleg Tour Tee Pack (2)',
    price: 55.00,
    category: 'apparel',
    tags: ['bundle'],
    images: [ 'https://images.unsplash.com/photo-1693275542358-29602edf6088' ],
    color: 'mixed',
    description: 'Two-pack of bootleg tour tees — mix & match sizes. Each one printed on vintage-washed cotton.',
    badge: 'BUNDLE'
  },
  {
    id: 'p6',
    slug: 'toxica-cap-green',
    name: 'La Tóxica Cap — Verde',
    price: 32.00,
    category: 'accessories',
    tags: ['hat'],
    images: [ 'https://images.unsplash.com/photo-1668959813575-8e68053e2fcc' ],
    color: 'green',
    description: 'Six-panel dad cap in forest green with chain-stitched La Tóxica script.',
    badge: ''
  },
  {
    id: 'p7',
    slug: 'princesa-poster',
    name: 'Princesa De La Noche Poster',
    price: 18.00,
    category: 'posters',
    tags: ['art'],
    images: [ IMG_ROSES ],
    color: 'pink',
    description: '24×36 in. offset-printed cover art poster. Ships rolled in a sturdy tube.',
    badge: ''
  },
  {
    id: 'p8',
    slug: 'tote-collection',
    name: 'Mariah Tote Collection',
    price: 42.00,
    category: 'accessories',
    tags: ['collection'],
    images: [ 'https://images.unsplash.com/photo-1774130108283-b7fded66b9bf' ],
    color: 'mixed',
    description: 'Three-color tote set (pink, cream, green). Limited run of 200 sets worldwide.',
    badge: 'LIMITED'
  }
];

export const MUSIC_RELEASES = [
  {
    id: 'm1',
    title: 'Princesa De La Noche',
    type: 'Album',
    year: '2024',
    cover: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/2vsc2dur_Screenshot%202026-04-17%20at%207.28.20%E2%80%AFPM.png',
    spotify: 'https://open.spotify.com/artist/0KKUc4amZyvswV2YL6WTar',
    tracks: 12
  },
  {
    id: 'm2',
    title: 'PERREITO',
    type: 'Single — 2× Platinum',
    year: '2020',
    cover: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/6508cifj_Screenshot%202026-04-17%20at%207.29.38%E2%80%AFPM.png',
    spotify: 'https://open.spotify.com/artist/0KKUc4amZyvswV2YL6WTar',
    tracks: 1
  },
  {
    id: 'm3',
    title: 'La Tóxica',
    type: 'EP',
    year: '2023',
    cover: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/7408k9ob_Screenshot%202026-04-17%20at%207.31.03%E2%80%AFPM.png',
    spotify: 'https://open.spotify.com/artist/0KKUc4amZyvswV2YL6WTar',
    tracks: 6
  },
  {
    id: 'm4',
    title: 'Nota Elevada',
    type: 'Single',
    year: '2022',
    cover: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/2vu2cv24_Screenshot%202026-04-17%20at%207.32.54%E2%80%AFPM.png',
    spotify: 'https://open.spotify.com/artist/0KKUc4amZyvswV2YL6WTar',
    tracks: 1
  }
];

export const TOUR_DATES = [
  { id: 't1', date: '2025-08-14', city: 'Miami, FL', venue: 'The Fillmore', status: 'ON SALE', link: '#' },
  { id: 't2', date: '2025-08-18', city: 'Orlando, FL', venue: 'House of Blues', status: 'ON SALE', link: '#' },
  { id: 't3', date: '2025-08-22', city: 'Atlanta, GA', venue: 'Tabernacle', status: 'FEW LEFT', link: '#' },
  { id: 't4', date: '2025-08-26', city: 'Houston, TX', venue: 'White Oak Music Hall', status: 'ON SALE', link: '#' },
  { id: 't5', date: '2025-08-30', city: 'Dallas, TX', venue: 'Echo Lounge', status: 'ON SALE', link: '#' },
  { id: 't6', date: '2025-09-04', city: 'Los Angeles, CA', venue: 'The Novo', status: 'SOLD OUT', link: '#' },
  { id: 't7', date: '2025-09-08', city: 'San Francisco, CA', venue: 'The Regency', status: 'ON SALE', link: '#' },
  { id: 't8', date: '2025-09-12', city: 'New York, NY', venue: 'Irving Plaza', status: 'ON SALE', link: '#' },
  { id: 't9', date: '2025-09-20', city: 'Madrid, ES', venue: 'La Riviera', status: 'ON SALE', link: '#' },
  { id: 't10', date: '2025-09-24', city: 'Barcelona, ES', venue: 'Razzmatazz', status: 'FEW LEFT', link: '#' }
];

export const GALLERY_IMAGES = [
  { id: 'g1', src: IMG_PORTRAIT_CHOKER, caption: 'Editorial / Billboard' },
  { id: 'g2', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/42xdjxys_Screenshot%202026-04-17%20at%207.21.00%E2%80%AFPM.png', caption: 'La Tóxica Live' },
  { id: 'g3', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/btg4rign_Screenshot%202026-04-17%20at%207.58.19%E2%80%AFPM.png', caption: 'Premios Lo Nuestro' },
  { id: 'g4', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/4aqd0ylm_Screenshot%202026-04-17%20at%208.05.49%E2%80%AFPM.png', caption: 'La Tóxica Glam' },
  { id: 'g5', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/xq238xv7_Screenshot%202026-04-17%20at%208.04.29%E2%80%AFPM.png', caption: 'Con Karol G' },
  { id: 'g6', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/hui0u2p9_Screenshot%202026-04-17%20at%207.58.43%E2%80%AFPM.png', caption: 'Miami Sunset' },
  { id: 'g7', src: IMG_MIAMI_GOLD, caption: 'Miami' },
  { id: 'g8', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/tvkzh9wi_Screenshot%202026-04-17%20at%207.59.55%E2%80%AFPM.png', caption: 'Celebrando' },
  { id: 'g9', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/p2eb9fie_Screenshot%202026-04-17%20at%208.05.10%E2%80%AFPM.png', caption: 'Music Video' },
  { id: 'g10', src: IMG_ARMS_UP, caption: 'Studio Session' },
  { id: 'g11', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/2ztd9dxu_Screenshot%202026-04-17%20at%208.05.37%E2%80%AFPM.png', caption: 'Studio Stream' },
  { id: 'g12', src: 'https://customer-assets.emergentagent.com/job_latindex-shop/artifacts/80x56bcy_Screenshot%202026-04-17%20at%207.59.42%E2%80%AFPM.png', caption: 'Backstage Snack' },
  { id: 'g13', src: IMG_ROSES, caption: 'Live at The Roxy' },
  { id: 'g14', src: IMG_DUO, caption: 'Premios Juventud' }
];

export const PRESS_ITEMS = [
  {
    id: 'pr1',
    outlet: 'Billboard',
    quote: 'Con tan solo 21 años, Mariah Angeliq es ya considerada una de las más importantes e influyentes artistas femeninas del género urbano.',
    year: '2023'
  },
  {
    id: 'pr2',
    outlet: 'RIAA',
    quote: '2× Platinum — "PERREITO" certified by the Recording Industry Association of America.',
    year: '2020'
  },
  {
    id: 'pr3',
    outlet: 'Premios Juventud',
    quote: 'Multiple nominations — Nuevo Impulso Urbano, Mejor Canción Urbana.',
    year: '2022'
  },
  {
    id: 'pr4',
    outlet: 'Premios Lo Nuestro',
    quote: 'Rising Female Urban Artist of the Year — nominee.',
    year: '2023'
  }
];

export const HERO_IMAGES = [
  IMG_PORTRAIT_CHOKER,
  IMG_ARMS_UP,
  IMG_DUO
];

export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/mariahangeliq',
  spotify: 'https://open.spotify.com/artist/0KKUc4amZyvswV2YL6WTar',
  tiktok: 'https://www.tiktok.com/@mariahangeliq',
  youtube: 'https://www.youtube.com/@MariahAngeliq',
  apple: 'https://music.apple.com',
  link: 'https://mariahangeliq.lnk.to/princesadelanoche'
};

export const VIDEOS = [
  {
    id: 'qzq2GcMe34E',
    title: 'Mariah Angeliq — Official Video',
    type: 'Music Video',
    duration: 'NEW',
    thumb: 'https://img.youtube.com/vi/qzq2GcMe34E/maxresdefault.jpg'
  },
  {
    id: '2JI4d_g0b7g',
    title: 'Mariah Angeliq — Live Session',
    type: 'Live',
    duration: 'LIVE',
    thumb: 'https://img.youtube.com/vi/2JI4d_g0b7g/maxresdefault.jpg'
  },
  {
    id: 'EXFKcl1DsFk',
    title: 'Mariah Angeliq — Visualizer',
    type: 'Visualizer',
    duration: 'HD',
    thumb: 'https://img.youtube.com/vi/EXFKcl1DsFk/maxresdefault.jpg'
  },
  {
    id: '34z8YXldqNk',
    title: 'Mariah Angeliq — Behind The Scenes',
    type: 'BTS',
    duration: 'EXCLUSIVE',
    thumb: 'https://img.youtube.com/vi/34z8YXldqNk/maxresdefault.jpg'
  },
  {
    id: 'HMQLkNsTxfI',
    title: 'Mariah Angeliq — Official Video',
    type: 'Music Video',
    duration: 'HD',
    thumb: 'https://img.youtube.com/vi/HMQLkNsTxfI/maxresdefault.jpg'
  },
  {
    id: '8vPxDAMqGeI',
    title: 'Mariah Angeliq — Official Video',
    type: 'Music Video',
    duration: 'HD',
    thumb: 'https://img.youtube.com/vi/8vPxDAMqGeI/maxresdefault.jpg'
  }
];
